import React, { useEffect } from "react";
import "./App.css";
import "./tokenly.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./header";
import FloatingSearchIcon from "./FloatingSearchIcon";
import Home from "./tokenlym";
import AboutUs from './aboutus';
import FindUs from './contact';
import Footer from "./footer";
import Terms from "./terms";
import Privacy from './privacy';
import DoctorView from "./doctorslist";
import AllDoctors from "./alldoctors";
import DoctorDetails from "./doctordetails";
import Login from './login';
import DoctorRegistration from './DoctorRegistration';
import ForgotPassword from "./forgotpass";
import TokenBook from "./tokenbook";
import TokenReceipt from "./tokenreceipt";
import TransactionHistory from "./transactionhistory";
import TokenHistory from "./tokenhistory";
import PaymentSuccess from "./PaymentSuccess";
import PaymentFailed from "./PaymentFailed";
import Wallet from "./wallet";
// import RegisterOtp from "./registerOtp";
import Trackii from "./trackii";
import DoctorDashboard from "./DoctorDashboard";
import ClinicHours from "./ClinicHours";
import NextHoliday from "./NextHoliday";
import Reports from "./Reports";
import ClinicProfile from "./ClinicProfile";
import StaffAll from "./StaffAll";
import SettingsDoctors from "./SettingsDoctors";
import MyDoctors from "./Mydoctors";
import ShareUrl from "./ShareUrl";
import Videos from "./Videos";
import SelfMode from "./SelfMode";
import ViewMode from "./ViewMode";



function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Standalone Route */}
          <Route path="/view-mode" element={<ViewMode />} />
          <Route path="/self-mode" element={<SelfMode />} />

          {/* Main App with Header/Footer */}
          <Route path="*" element={
            <>
              <Header />
              <FloatingSearchIcon />
              <main id="main-content">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<AboutUs />} />
                  <Route path="/contact" element={<FindUs />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/doctors" element={<DoctorView />} />
                  <Route path="/alldoctors" element={<AllDoctors />} />
                  <Route path="/doctor/:id" element={<DoctorDetails />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/id-registration" element={<DoctorRegistration />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  {/* <Route path="/register-otp" element={<RegisterOtp />} /> */}
                  <Route path="/token-book" element={<TokenBook />} />
                  <Route path="/token-receipt/:id" element={<TokenReceipt />} />
                  <Route path="/transaction-history" element={<TransactionHistory />} />
                  <Route path="/token-history" element={<TokenHistory />} />
                  <Route path="/payment-success" element={<PaymentSuccess />} />
                  <Route path="/payment-failed" element={<PaymentFailed />} />
                  <Route path="/wallet" element={<Wallet />} />

                  <Route path="/trackii" element={<Trackii />} />
                  <Route path="/doctor-dashboard" element={<DoctorDashboard />} />
                  <Route path="/clinic-hours" element={<ClinicHours />} />
                  <Route path="/next-holiday" element={<NextHoliday />} />
                  <Route path="/reports" element={<Reports />} />
                  <Route path="/clinic-profile" element={<ClinicProfile />} />
                  <Route path="/staff" element={<StaffAll />} />
                  <Route path="/doctor-settings" element={<SettingsDoctors />} />
                  <Route path="/my-doctors" element={<MyDoctors />} />
                  <Route path="/share-url" element={<ShareUrl />} />
                  <Route path="/videos" element={<Videos />} />
                </Routes>
              </main>
              <Footer />
            </>
          } />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;


